module.exports = __webpack_public_path__ + "img/megaphone.f7d82b8.png";